// All needed imports
import { SelectModel } from '../../core/models/select.model';
import { CalendarBaseModel } from '../../core/models/calendar-base.model';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { RadioCardListModel } from '../../../app/core/models/radio-card-list.model';
import { RadioCardModel } from '../../core/models/radio-card.model';
import { CheckboxModel } from '../../core//models/checkbox.model';
import { InputModel } from '../../core//models/input.model';
import { Numbers } from 'src/app/utils/constants';
import { setCheckboxModel, setInputModel, setRadioCardModel, setRadioPointModel,
  setSelectModel, setSelectOptions, setSelectValue } from 'src/app/utils/labels.utils';
import { commonLegalInsuredData, setDateLegalFormConfig } from 'src/app/utils/form-utils-extended';
import { commonLegalDomiciliation, guaranteeSelectionLegal } from 'src/app/utils/form-utils.extended-extended';

/**
 * Export the obj to be used in the angular components app
 * It has attributes and methods
 */
export const FORM_CONFIG: any = {
  currentStep: new BehaviorSubject(1),
    // Decrement the current step
  stepDecrement(): void {
    this.currentStep.pipe(
      take(1)
    ).subscribe(numStep => {
      let numeroPaso = 1;
      if (numStep > 1) {
        --numStep;
        numeroPaso = numStep;
      }
      this.currentStep.next(numeroPaso);
    });
  },
  // Increment the step
  stepIncrement(): void {
    this.currentStep.pipe(
      take(1)
    ).subscribe(numStep => {
      let numeroPaso: number = numStep;
      if (numStep !== Numbers.number4) {
        ++numStep;
        numeroPaso = numStep;
      }
      this.currentStep.next(numeroPaso);
    });
  },
  // Date attribute
  date: new CalendarBaseModel(setDateLegalFormConfig('particularLegalAsistance')),
  // codePromotional attribute
  codePromotional: new InputModel(setInputModel(['particularLegalAsistance', 'codePromotional'], 'form1.promotional', {value: ''})),
  // inssuranceType attribute
  // Basico o Completo types
  insuranceType: new RadioCardListModel({
    linkFormPath: ['particularLegalAsistance', 'insuranceType'],
    radioCardList: [
      new RadioCardModel(setRadioCardModel(Numbers.number0, 'legal.coverage0')),
      new RadioCardModel(setRadioCardModel(Numbers.number1, 'legal.coverage1'))
    ]
  }),
  // insuredData attribute
  insuredData: {
    // document type
    documentType: new SelectModel(
      setSelectModel(['particularLegalAsistance', 'insuredData', 'documentType'],
        setSelectValue('form1.bussines.document-selector', 'form1.bussines.document-selector.error'),
        setSelectOptions('', '', [{ name: 'NIF', id: Numbers.number1 },
        { name: 'NIE', id: Numbers.number3 }])
      )
    ),
    // Name
    name: new InputModel( setInputModel(['particularLegalAsistance', 'insuredData', 'name'], 'form1.particular.name',
    { requiredText: 'form1.particular.name.error'}, true)),
    // province
    province: new InputModel( setInputModel(['particularLegalAsistance', 'insuredData', 'province'],  'form1.province',
    { requiredText: 'form1.default-error'}, true, true)),
    // Rented House
    rentedHouse: new CheckboxModel(
      setCheckboxModel(['particularLegalAsistance', 'insuredData', 'rentedHouse'],
        'legal.rented-house', true)),
    // Rendted House Data
    rentedHouseData: {
      // Direction
      direction: new InputModel( setInputModel(['particularLegalAsistance', 'insuredData', 'rentedHouseData', 'direction'], 'legal.rented-direction',
      { requiredText: 'legal.rented-direction-error'})),
      // postal Code
      postalCode: new InputModel( setInputModel(['particularLegalAsistance', 'insuredData', 'rentedHouseData', 'postalCode'], 'legal.rented-postalcode',
      { cpError: 'form1.default-cp-error', maxlength: '5', requiredText: 'legal.rented-zipcode-error'})),
      // Municipality
      municipality: new SelectModel(
        setSelectModel(['particularLegalAsistance', 'insuredData', 'rentedHouseData', 'municipality'],
          setSelectValue('legal.rented-municipality'),
          setSelectOptions('', '', [])
        )
      ),
      // Province
      province: new InputModel( setInputModel(['particularLegalAsistance', 'insuredData', 'rentedHouseData', 'province'], 'legal.rented-province', {})),
      // Country
      country: new SelectModel(
        setSelectModel(['particularLegalAsistance', 'insuredData', 'rentedHouseData', 'country'],
          setSelectValue('legal.rented-country'),
          setSelectOptions('España', 'España', [{ name: 'España', id: Numbers.number0 },
          { name: 'Rome', id: Numbers.number1 }, { name: 'London', id: Numbers.number2 }])
        )
      )
    },
    ...commonLegalInsuredData('particularLegalAsistance')
  },
  // Domiciliation attribute
  domiciliation: {
    ...commonLegalDomiciliation('particularLegalAsistance')
  },
  // Guarantee attribute
  guaranteeSelection: guaranteeSelectionLegal('particularLegalAsistance')
};
